import React from 'react';
import { useVerificationWizard } from '../useVerificationWizard';
import VerificationStepActionBar from '../VerificationStepActionBar';
import ClinicContactsView from '../../ClinicContactsView';
import { VERIFICATION_STEPS } from '../../../types/verification';

const STEP = VERIFICATION_STEPS.CONTACTS;

const VerifyContactsStep: React.FC = () => {
  const {
    clinic,
    markStepConfirmed,
    markStepSkipped,
    getStepStatus,
    isSaving,
  } = useVerificationWizard();

  if (!clinic) return null;

  return (
    <div className="wizard-step">
      <h2>Verify Contacts</h2>
      <p className="step-description">
        Review the clinic's contacts. You can add, edit, or remove contacts directly below.
      </p>

      <ClinicContactsView clinicId={clinic.id} canEdit={true} />

      <VerificationStepActionBar
        stepStatus={getStepStatus(STEP)}
        isSaving={isSaving}
        onSaveChanges={async () => markStepConfirmed(STEP)}
        onNoChanges={() => markStepConfirmed(STEP)}
        onSkip={(notes) => markStepSkipped(STEP, notes)}
      />
    </div>
  );
};

export default VerifyContactsStep;
